import { CSSProperties } from 'react';
import Media from './media';

export default class Link {
  label?: string;
  route: string;
  usePageTransition: boolean;
  icon?: Media;
  customStyles?: CSSProperties;
  template?: string;
  tags?: string[];
  analyticsAttributes?: any;

  constructor(props: any) {
    const {
      label,
      route,
      icon,
      customStyles,
      template,
      tags,
      analyticsAttributes,
      textColor
    } = props;
    const usePageTransitionIsSet =
      props.usePageTransition !== null && props.usePageTransition !== undefined;

    this.label = label;
    this.route = route || '/';
    this.icon = icon ? new Media(icon) : undefined;
    this.customStyles = customStyles || {};
    this.template = template;
    this.usePageTransition = usePageTransitionIsSet
      ? props.usePageTransition
      : true;
    this.tags = tags;
    this.analyticsAttributes = analyticsAttributes;

    if (this.customStyles) {
      this.customStyles = {
        ...this.customStyles,
        color: this.customStyles.color || textColor
      };
    }
  }
}
